import content from '../assets/siteContent.json';

export default content;

// Text-only interpolation: JSON never contains executable code or HTML.
export function format(template, values = {}) {
  return template.replace(/\{(\w+)\}/g, (match, key) => String(values[key] ?? match));
}
export function countLabel(unit, count) {
  return format(content.common[unit][Number(count) === 1 ? 'one' : 'other'], { count });
}
